import { createIntl, createIntlCache } from 'react-intl'
import { ROUTER_BASENAME } from '../common/const'

import enUS from '../locales/en-US.json'
import jaJP from '../locales/ja-JP.json'
import zhTW from '../locales/zh-TW.json'

const messages = {
  'zh-CN': zhTW,
  'zh-TW': zhTW,
  'en-US': enUS,
  'ja-JP': jaJP,
}

const cache = createIntlCache()

const errCode = {
  OK: '0000',
  NOT_SET_PWD: 'user_password_not_set',
  USER_NOT_REGISTER: 'user_not_register',
  USER_PASSWORD_NOT_CORRECT: 'user_password_not_correct',
}

const errMsg = {
  // v3
  '-1': 'err_code_-1',
  C002: 'err_code_C002',
  A011: 'err_code_A011',
  A012: 'err_code_A012',
  B008: 'err_code_B008',
  A000: 'err_code_A000',
  A005: 'err_code_A005',
  B001: 'err_code_B001',
  B007: 'err_code_B007',
  B003: 'err_code_B003',
  B004: 'err_code_B004',
  B009: 'err_code_B009',
  A015: 'err_code_A015',
  A013: 'err_code_A013',
  A002: 'err_code_A002',
  A009: 'err_code_A009',
  B006: 'err_code_B006',
  A014: 'err_code_A014',
  A031: 'err_code_A031',
  A032: 'err_code_A032',
  A033: 'err_code_A033',
  A034: 'err_code_A034',
  A035: 'err_code_A035',
  A001: 'err_code_A001',
  A038: 'err_code_A038',
  A008: 'err_code_A008',

  // v5
  missing_required_param: {
    'can not read the required parameter from request': 'err_code_v5_001',
  },
  send_email_fail: {
    'fail to send email': 'err_code_v5_002',
  },
  check_email_code_fail: {
    'email code not exist': 'err_code_v5_003',
    'email code had expired': 'err_code_v5_004',
    'email code not correct': 'err_code_v5_005',
  },
  operator_error: {
    'account is not login': () => {
      window.location.href = `/${ROUTER_BASENAME}/login`
    },
    'account team not found': 'err_code_v5_006',
  },
  team_not_exist: {
    'failed to get info from db': 'err_code_v5_006',
    'team not exist': 'err_code_v5_006',
  },
  username_is_empty: {
    'not had register username': 'err_code_v5_007',
  },
  user_already_exist: {
    'user already exist': 'err_code_v5_008',
    'user exist already': 'err_code_v5_012',
  },
  user_not_register: {
    'user not register': 'err_code_v5_009',
  },
  user_not_exist: {
    'user not exist': 'err_code_v5_009',
    'invite account is not exist in this team': 'err_code_v5_014',
  },
  user_password_not_set: {
    'user password not set': 'err_code_v5_010',
  },
  user_password_not_correct: {
    'user password not correct': 'err_code_v5_011',
  },
  password_too_weak: {
    'user passport too weak': 'err.pwd.too.weak',
  },
  invite_code_not_exist: {
    'invite code error or expired': 'err_code_v5_013',
  },
}

export const GetErrMsg = (code, desc) => {
  const intl = createIntl(
    {
      locale: window.react_intl_local,
      messages: messages[window.react_intl_local],
    },
    cache
  )

  let intlId = ''
  if (errMsg[code]) {
    console.log('desc', desc, errMsg, code)
    if (desc) {
      const idCode = errMsg[code][desc]
      console.log('idCode', idCode)
      if (typeof idCode === 'string') {
        intlId = idCode
      } else if (typeof idCode === 'function') {
        idCode()
        return 'need login'
      }
    } else {
      intlId = errMsg[code]
    }
  } else {
    intlId = errMsg[-1]
  }

  let msg = intlId && intl.formatMessage({ id: intlId })
  if (msg) return msg

  // 兜底。如果拿不到预期的错误信息，就返回错误码英文描述。
  return code
}

export default errCode
